import React from "react";
import { useState, useRef } from "react";

export default function Header() {
  const checkboxRef = useRef();
  const [isActive, setIsActive] = useState(false);
  const onClickUrl = () => {
    checkboxRef.current.checked = false;
  };
  return (
    <header className="header">
      <span className="signature">Karim Bahri</span>
      <input
        type="checkbox"
        className="navBar__checkbox"
        id="navBar__checkbox"
        ref={checkboxRef}
      />
      <label htmlFor="navBar__checkbox" className="navBar__toggle">
        {/* <FontAwesomeIcon className={"fa fa-solid fa-bars"} icon={faBars} />
        <FontAwesomeIcon
          className={"fa fa-sharp fa-solid fa-xmark"}
          icon={faXmark}
        /> */}
        <svg
          className={`ham hamRotate ham8 ${isActive ? "active" : ""}`}
          viewBox="0 0 100 100"
          width="70"
          onclick="this.classList.toggle('active')"
          onClick={() => setIsActive(!isActive)}
        >
          <path
            className="line top"
            d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20"
          />
          <path className="line middle" d="m 30,50 h 40" />
          <path
            className="line bottom"
            d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20"
          />
        </svg>
      </label>
      <ul>
        <li>
          <a href="#whoami" onClick={onClickUrl}>
            WHO AM I
          </a>
        </li>
        <li>
          <a href="#services" onClick={onClickUrl}>
            WHAT I DO
          </a>
        </li>
        <li>
          <a href="#work" onClick={onClickUrl}>
            WORK
          </a>
        </li>
        <li>
          <a href="#contact" onClick={onClickUrl}>
            CONTACT
          </a>
        </li>
      </ul>
    </header>
  );
}

